import React from 'react';
import { AvForm, AvField } from 'availity-reactstrap-validation';
const UserManagement = () => {
    const prepareObject = (values) => {

    }
    return (
        <div className="user-management">
            <div className="camera-config-header">
                <span>Home</span>
                <img src="/icon/arrowleft.svg" alt=">"/>
                <span>System Management</span>
                <img src="/icon/arrowleft.svg" alt=">"/>
                <span>User Management</span>
            </div>
            <div className="camera-config-content">
                <div className="row">
                    <div className="col-md-3">
                        <div className="my-avform">
                            <AvForm onValidSubmit={(e, v) => prepareObject(v)}>
                                <AvField
                                    name="Username"
                                    label="Username"
                                    // value={item.value ? item.value : ""}
                                    placeholder="text"
                                />
                                <AvField
                                    name="Password"
                                    label="Password"
                                    // value={item.value ? item.value : ""}
                                    placeholder="text"
                                />
                                <AvField
                                    name="New_Password"
                                    label="New Password"
                                    // value={item.value ? item.value : ""}
                                    placeholder="text"
                                />
                                <AvField
                                    name="Confirm_Password"
                                    label="Confirm Password"
                                    // value={item.value ? item.value : ""}
                                    placeholder="text"
                                />

                            </AvForm>
                            <div className="d-flex justify-content-end">
                                <button className="add-btn">Change password</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UserManagement;